import logger from "../art-logger-config";

// All current callers invoke this fire-and-forget. Any rejection here
// would surface as an unhandled promise rejection, so failures are
// logged internally and the returned promise always resolves.
//
// `navigator.clipboard` can be undefined even in a secure context
// (blocked by Permissions-Policy, older browsers, etc.), so the async
// branch is guarded and wrapped in try/catch — a synchronous throw on
// property access would otherwise escape the trailing `.catch()`.
export const CopyToClipboard = (input: string): Promise<void> => {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      return navigator.clipboard.writeText(input).catch((err: unknown) => {
        logger.error(`CopyToClipboard failed: ${String(err)}`);
      });
    } catch (err: unknown) {
      logger.error(`CopyToClipboard failed: ${String(err)}`);
      return Promise.resolve();
    }
  }
  try {
    const textField = document.createElement("textarea");
    textField.innerText = input;
    document.body.appendChild(textField);
    textField.select();
    const successful = document.execCommand("copy");
    textField.remove();
    if (!successful) {
      logger.error("CopyToClipboard failed: copy command was not accepted");
    }
  } catch (err: unknown) {
    logger.error(`CopyToClipboard failed: ${String(err)}`);
  }
  return Promise.resolve();
};
